import React, { useState } from "react";
import Plot from "react-plotly.js";

import { AddFilterBaseFunc, chartAttrs, defaultConfig, defaultStyles, IFilterKeys, IFilters, RemoveFilterBaseFunc } from "models/core";
import { DashboardFilterKeys } from "models/mdt";
import { Morphology } from "models/mdt/plotdata";
import { PlotData } from "plotly.js";
import { Dialog } from "@mui/material";
import { addFilterFactory } from "helpers/filterHelper";
import { DashTable } from "components/common/DashTable";
import { DashChart } from "components/common/DashChart";
import { ChartIcons } from "components/common/ChartIcons";
import { SimpleBreadcrumb } from "components/common/SimpleBreadcrumb";
import { truncateStringWithEllipsis } from "helpers/stringHelper";
import { chartDimesionsCalc, ChartOrientation, ChartType, QoolDashChart } from "../core";
import watermark from "../../static/qca-black.png";
import { CreateChart } from "components/common/CreateChart";
import { defText, defTextTemplate } from "defaults";

interface IProps {
	plotData: Morphology.IPlotData;
	activeFilters: IFilters<IFilterKeys>;
	addFilterFn: AddFilterBaseFunc<typeof DashboardFilterKeys>;
    removeFilterFn: RemoveFilterBaseFunc<typeof DashboardFilterKeys>;
}

/**
 * Reviews by service chart / My MDTs
 */
export function PatientsByMorphChart(props: IProps) {

	return (
		<QoolDashChart
			xAxis={{ horizontalOrientation: { label: "Number of Diagnoses" }, verticalOrientation: { label: "Morphology" }  }}
			yAxis={{ horizontalOrientation: { label: "Morphology" }, verticalOrientation: { label: "Number of Diagnoses" }	}}
			chartOrder={{ horizontalOrientation: { reversed: false }, verticalOrientation: { reversed: true } }}
			defaultChartOrientation={ChartOrientation.Horizontal}
			defaultChartType={ChartType.Bar}
			chartTitle="Morphology"
			filterKey={DashboardFilterKeys.Morphology.key}
			plotData={[props.plotData]}
			activeFilters={props.activeFilters}
			addFilterFn={props.addFilterFn}
			removeFilterFn={props.removeFilterFn}
			hoverText="Diagnoses"
			chartIcons={{
				line: false
			}}
			chartDimensions={{
				chartHeightProportion: 50,
				parentColNumber: 12,
				tabColNumber: 4
			}}
			sortUnknownToEnd={true}
		/>
	)

}
